module.exports = __webpack_public_path__ + "img/11.90be231d.jpg";